<template>
  <div>
    <div ref="search" style="position: relative">
      <div class="search" id="search">
        <div class="filter" @click="open">
          <!--        <van-icon name="filter-o" color="#fff"/>-->
          <div
              style="color:#fff; font-size: 15px; margin-right: 4px; padding-left: 4px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
            {{ show ? '收起' : searchTitle }}
          </div>
          <van-icon :name="show ? 'arrow-up' :'arrow-down'" color="#fff"/>
        </div>
        <div class="search-item">
          <form action="/">
            <van-search
                v-model="value"
                :disabled="inputDisable"
                :clearable="false"
                background="#0093FF"
                placeholder="请输入搜索关键词"
                @search="onSearch"
            >
              <template #right-icon>
                <van-icon v-if="value" name="clear" color="#adb5bd" size="20" @click="clear"/>
              </template>
            </van-search>
          </form>
        </div>
        <div v-if="showStatus" style="width: 40px;">
          <van-popover
              v-model="showPopover"
              trigger="click"
              :actions="actions"
              @select="onSelect"
              placement="bottom-end"
          >
            <template #reference>
              <van-icon name="bars" size="30px" color="#fff"></van-icon>
            </template>
          </van-popover>
        </div>
        <div v-if="showPersonFilter" style="width: 40px; text-align: center;">
          <img class="user-select-icon" src="../../assets/userSelect.png" alt="" @click.stop="openPersonPopup" />
        </div>
        <!--      <div v-if="typeValue === 'todo'" style="width: 40px; z-index: 999;">-->
        <!--        <img class="img" src="../../assets/mul.png" alt="" @click="changeMultipule">-->
        <!--&lt;!&ndash;        <van-icon name="apps-o" size="30px" color="#fff" @click="changeMultipule"/>&ndash;&gt;-->
        <!--      </div>-->
      </div>

      <Transition name="fade">
        <div v-if="show" class="right" ref="treeSelect"
             style="position: fixed; left: 0; top: 100px; width: 100%; z-index: 999; height: calc(100vh - 105px); background-color: #fff; padding-bottom: 80px; padding-top: 5px">
          <!--        <van-radio-group v-model="activeId">-->
          <!--          <van-cell-group>-->
          <!--            <template v-for="(item, index) in treeList">-->
          <!--              <van-cell v-if="item.show" clickable>-->
          <!--                <template #title>-->
          <!--                  <div style="display: flex; align-items: center" :style="[{ paddingLeft: item.rank*12 + 'px', zIndex: item.rank*-1 +50}]" @click.stop="treeItemTap(item, index)">-->

          <!--                    <div style="margin-left: 2px; font-size: 16px;">{{item.name}}</div>-->
          <!--                    <div class="badge" v-if="typeValue === 'todo' && item.badge !== 0" style="display: flex;align-items: center;justify-content: center">{{item.badge}}</div>-->

          <!--                  </div>-->
          <!--                </template>-->
          <!--                <template #right-icon>-->
          <!--                </template>-->
          <!--              </van-cell>-->
          <!--            </template>-->
          <!--          </van-cell-group>-->
          <!--        </van-radio-group>-->
          <div v-for="(item, index) in treeList">
            <div class="mix-tree-item" :class="{
							show: item.show,
							last: item.lastRank,
							showchild: item.showChild,
							active: showId === item.id && item.showChild
							}" style="display: flex; justify-content: space-between; font-size: 17px" :style="[{
							paddingLeft: item.rank*16 + 'px',
							zIndex: item.rank*-1 +50}]" @click.stop="treeItemTap(item, index)">
              <div class="selectArea" style="flex:1; display: flex; align-items: center; height: 100%;">
                <template>
                  <img
                      v-if="item.rank === 0" style="width:18px; height: 18px;"
                      src="../../assets/server.png"
                  />
                  <img
                      v-if="item.lastRank && item.rank !== 0"
                      style="width:22px; height: 22px;"
                      src="../../assets/wenjian.png"
                  />
                  <img
                      v-if="!item.lastRank && item.rank === 1" style="width:16px; height: 16px;"
                      src="../../assets/wenjianjia.png"
                  />
                </template>
                <span :class="{isBold: item.rank === 0}" style="margin-left: 5px">{{ item.name }}</span>
                <van-badge
                    style="margin-left: 5px"
                    v-if="item.badge > 0"
                    :content="item.badge"
                    color="#ee0a24"
                    class="tree-item-badge"
                />
              </div>
              <div style="width: 40px; text-align: center" v-if="!item.lastRank" @click.stop="showHide(item, index)">
                <img
                    v-if="!item.showChild" style="width:24px; height: 24px;"
                    src="../../assets/fujiedianzhankai.png"
                />
                <img
                    v-else style="width:24px; height: 24px;"
                    src="../../assets/fujiedianshouqi.png"
                />
              </div>
              <div style="width: 40px; text-align: center" v-else>
              </div>
            </div>
          </div>
          <!--        :class="{'filter-item' : treeList[activeIndex].badge === 0}"-->
          <!--        <van-tree-select-->
          <!--            :items="treeList"-->
          <!--            :main-active-index.sync="activeIndex"-->
          <!--            :active-id="activeId"-->
          <!--            @click-nav="clickLeft"-->
          <!--            @click-item="selectItem"-->
          <!--        >-->
          <!--          <template #content>-->
          <!--            <van-tree-select :items="rightData" :main-active-index.sync="index" :active-id.sync="activeId">-->
          <!--              <template #content>-->
          <!--                <div v-for="(item, index) in rightFilterData" :key="index" class="van-tree-select__item van-ellipsis" :class="{'van-tree-select__item&#45;&#45;active' : item.id === activeId}"-->
          <!--                     @click="confirm(item.id)">-->
          <!--                  <van-badge :content="5">-->
          <!--                    <span>{{item.text}} <span v-if="item.badge && item.badge != 0" style="color: red">（{{item.badge}}）</span></span>-->
          <!--                  </van-badge>-->
          <!--                  <van-icon name="success" v-if="item.id === activeId" class="van-tree-select__item&#45;&#45;active" style="position: absolute; top: 50%; right: 16px; margin-top: -8px; font-size: 16px" />-->
          <!--                </div>-->
          <!--              </template>-->
          <!--            </van-tree-select>-->
          <!--          </template>-->
          <!--        </van-tree-select>-->
          <div
              style="position: fixed; left: 0; bottom:0; width: 100%; height: 50px; display: flex; justify-content: center; align-items: center; background-color:#fff; z-index:9999">
            <van-button style="width: 80%;" round  type="info" @click="cancel">查 看 全 部</van-button>
          </div>
        </div>
      </Transition>

      <van-popup
          v-model="showPersonPopup"
          position="bottom"
          :style="{ width: '100%', height: '100vh' }"
          get-container="body"
      >
        <div class="person-popup">
            <div class="person-popup-header">
              <div class="person-popup-header-main">
                <div class="person-popup-title-text">选择人员</div>
              </div>
              <div class="person-popup-close" @click="showPersonPopup = false">
                <van-icon name="cross" size="18"/>
            </div>
            <div class="person-popup-title">选择人员</div>
            <van-icon name="cross" size="22" @click="showPersonPopup = false"/>
          </div>
          <div v-if="personLoading" class="person-popup-loading">
            <van-loading size="24px" vertical>加载中...</van-loading>
          </div>
          <div v-else-if="personGroups.length === 0" class="person-popup-empty">
            暂无人员数据
          </div>
          <div v-else class="person-popup-content">
            <van-index-bar :index-list="personIndexList" highlight-color="#ee0a24" :sticky="false">
              <div v-for="group in personGroups" :key="group.index">
                <van-index-anchor :index="group.index" />
                <van-cell
                    style="font-size: 20px"
                    v-for="person in group.list"
                    :key="person"
                    :title="person"
                    clickable
                    @click="selectPerson(person)"
                >
                  <template #title>
                    <div style="font-size: 20px; padding-left: 10px">{{person}}</div>
                  </template>
                </van-cell>
              </div>
            </van-index-bar>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import FlowSettingService from "../../api/sys/flowSettingService";
import Vue from "vue";

export default {
  name: "search",
  props: {
    showStatus: {
      type: Boolean,
      default: false
    },
    typeValue: {
      type: String,
      default: ''
    },
    isMultiple: {
      type: Boolean,
      default: false
    },
    showPersonFilter: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      show: false,
      value: '',
      filterData: [],
      activeId: '',
      activeIndex: '0',
      index: 0,
      inputDisable: false,
      flowSettingService: null,
      treeList: [],
      showPopover: false,
      actions: [{text: '审核中', id: '1'}, {text: '已审核', id: '2'}, {text: '已终止', id: '5'}],
      searchTitle: '系统分类',
      leftTitle: '',
      rightTitle: '',
      name: '',
      businessTable: '',
      type: '',
      showId: '',
      showPersonPopup: false,
      personLoading: false,
      personLoaded: false,
      personGroups: []
    }
  },
  watch: {
    show(newV, oldV) {
      this.inputDisable = newV;
    },
  },
  computed: {
    rightFilterData() {
      if (this.rightData.length > 0 && this.rightData[this.index].children) {
        return this.rightData[this.index].children
      } else {
        return []
      }
      // return []
    },
    personIndexList() {
      return this.personGroups.map(item => item.index)
    }
  },
  created() {
    this.flowSettingService = new FlowSettingService()
    this.init()
  },
  mounted() {
    // 在文档中添加点击事件监听器，用于关闭下拉内容
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    // 组件销毁前移除点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    init() {
      this.treeList = []
      this.flowSettingService.queryTreeData().then((res) => {
        // this.treeList = this.replaceFieldName(res.data, 'name', 'text')
        // this.leftTitle = this.treeList[0].text
        // this.calculateTreeSum(res.data, 'badge', 'children')
        res.data.forEach(item => {
          if (item.children && item.children.length > 0) {
            item.children.forEach(child => {
              if (child.children && child.children.length > 0) {
                child.badge = child.children.reduce((acc, cur) => acc + cur.badge, 0)
              }
            })
          }
        })
        this.renderTreeList(res.data)

      })
    },
    calculateTreeSum(nodes, valueKey = 'value', childrenKey = 'children') {
      if (!nodes || nodes.length === 0) return 0;

      let totalSum = 0;

      for (const node of nodes) {
        if (node.type === '1') {
          totalSum += node[valueKey] || 0;
          continue;
        }
        if (node[childrenKey] && node[childrenKey].length > 0) {
          // 先计算子节点的和
          const childrenSum = this.calculateTreeSum(node[childrenKey], valueKey, childrenKey);
          node[valueKey] = childrenSum;
          totalSum += childrenSum;
        } else {
          totalSum += node[valueKey] || 0;
        }
      }

      return totalSum;
    },
    open() {
      this.show = !this.show
      this.$emit('changeShow', this.show)
    },
    close() {
      this.show = false
      this.$emit('changeShow', this.show)
    },
    cancel() {
      this.searchTitle = '系统分类'
      this.activeId = ''
      this.name = ''
      this.type = ''
      this.businessTable = ''
      this.$emit('select', '')
      this.close()
    },
    // 确认选中的数据
    confirm() {
      this.searchTitle = this.name
      this.$emit('select', {
        name: this.type,
        businessName: this.name,
        businessTable: this.businessTable
      })
      this.close()
    },
    clear() {
      this.value = ''
      switch (this.typeValue) {
        case 'todo':
          Vue.cookie.delete('todoSearchValue')
          this.$emit('refreshList', this.value)
          break;
        case 'done':
          Vue.cookie.delete('doneSearchValue')
          this.$emit('refreshList', this.value)
          break;
        case 'sponsor':
          Vue.cookie.delete('sponsorSearchValue')
          this.$emit('refreshList', this.value)
          break;
      }
    },
    clickLeft(index) {
      this.leftTitle = this.treeList[index].text
    },
    selectItem(data) {
      if (this.activeId === data.id) {
        this.activeId = ''
        this.rightTitle = ''
        return
      }
      this.activeId = data.id
      this.rightTitle = data.text
    },
    handleClickOutside(event) {
      // 检查点击的区域是否在下拉表单外部
      if (!this.$refs.search.contains(event.target)) {
        this.show = false;
        this.$emit('changeShow', this.show)
      }
    },
    // 更改数组字段名
    replaceFieldName(treeArray, oldFieldName, newFieldName) {
      if (!Array.isArray(treeArray)) {
        return treeArray;
      }

      return treeArray.map(item => {
        const newItem = {...item};

        // 替换字段名
        if (newItem.hasOwnProperty(oldFieldName)) {
          newItem[newFieldName] = newItem[oldFieldName];
          delete newItem[oldFieldName];
        }

        // 递归处理嵌套对象
        Object.keys(newItem).forEach(key => {
          if (Array.isArray(newItem[key]) || typeof newItem[key] === 'object') {
            newItem[key] = this.replaceFieldName(newItem[key], oldFieldName, newFieldName);
          }
        });
        return newItem;
      });
    },
    filterTree(tree) {
      const filteredTree = [];

      tree.forEach(node => {
        const newNode = {
          id: node.id,
          text: node.name,
          children: []
        };

        if (node.children.length === 0 || node.children.every(child => child.children.length === 0)) {
          newNode.children = []; // 最后一层节点，直接加入新树中
          filteredTree.push(newNode);
        } else if (node.children.length > 0) {
          newNode.children = node.children.map(child => ({
            id: child.id,
            text: child.name,
            children: []
          }));
          filteredTree.push(newNode);
        }
      });
      return filteredTree;
    },
    //扁平化树结构
    renderTreeList(list = [], rank = 0, parentId = []) {
      list.forEach(item => {
        this.treeList.push({
          id: item.id,
          type: item.type,
          name: item.name,
          formKey: item.formKey,
          searchName: item.searchName || '',
          mark: item.mark,
          parentId,  // 父级id数组
          rank,  // 层级
          showChild: false,  // 子级是否显示
          show: rank === 0,  // 自身是否显示
          badge: item.badge
        })
        if (Array.isArray(item.children) && item.children.length > 0) {
          let parents = [...parentId];
          parents.push(item.id);
          this.renderTreeList(item.children, rank + 1, parents);
        } else {
          this.treeList[this.treeList.length - 1].lastRank = true;
        }
      })
    },
    // 点击
    treeItemTap(item) {
      let id = item.id;
      this.activeId = item.id;
      this.name = item.name;
      this.businessTable = item.formKey
      this.type = item.mark
      this.confirm()
      // if(item.lastRank === true){
      //   //点击最后一级时触发事件
      //   this.searchTitle = item.name
      //   this.activeId = item.id
      //   Vue.cookie.set('searchTitle', item.name)
      //   Vue.cookie.set('searchTitleId', item.id)
      //   this.$emit('select', item.name)
      //   this.$emit('clearResult')
      //   this.close()
      //   return;
      // }
    },
    showHide(item){
      let list = this.treeList;
      let id = item.id;
      this.showId = id;
      item.showChild = !item.showChild;
      list.forEach(childItem => {
        if (item.showChild === false) {
          //隐藏所有子级
          if (!childItem.parentId.includes(id)) {
            return;
          }
          if (childItem.lastRank !== true) {
            childItem.showChild = false;
          }
          childItem.show = false;
        } else {
          if (childItem.parentId[childItem.parentId.length - 1] === id) {
            childItem.show = true;
          }
        }
      })
    },
    onSearch() {
      switch (this.typeValue) {
        case 'todo':
          Vue.cookie.set('todoSearchValue', this.value)
          this.$emit('refreshList', this.value)
          break;
        case 'done':
          Vue.cookie.set('doneSearchValue', this.value)
          this.$emit('refreshList', this.value)
          break;
        case 'sponsor':
          Vue.cookie.set('sponsorSearchValue', this.value)
          this.$emit('refreshList', this.value)
          break;
      }
    },
    onSelect(data) {
      this.$emit('selectStatus', data.id)
      this.showPopover = false
    },
    openPersonPopup() {
      this.show = false
      this.showPopover = false
      this.$emit('changeShow', this.show)
      this.showPersonPopup = true
      this.loadPersonList()
    },
    loadPersonList() {
      if (this.personLoaded || this.personLoading || this.typeValue !== 'todo') {
        return
      }
      this.personLoading = true
      const userId = Vue.cookie.get('userId')
      this.flowSettingService.queryCreateUserByUserId(userId).then(({data}) => {
        const records = Array.isArray(data) ? data : []
        const names = [...new Set(records.map(item => (item.create_name || '').trim()).filter(Boolean))]
        this.personGroups = this.groupPersons(names)
        this.personLoaded = true
      }).catch(() => {
        this.personGroups = []
        this.$toast.fail('人员列表加载失败')
      }).finally(() => {
        this.personLoading = false
      })
    },
    groupPersons(names = []) {
      const groups = {}
      names.sort((a, b) => a.localeCompare(b, 'zh-Hans-CN'))
      names.forEach(name => {
        const index = this.getPersonIndex(name)
        if (!groups[index]) {
          groups[index] = []
        }
        groups[index].push(name)
      })

      return Object.keys(groups)
          .sort((a, b) => {
            if (a === '#') return 1
            if (b === '#') return -1
            return a.localeCompare(b)
          })
          .map(index => ({
            index,
            list: groups[index]
          }))
    },
    getPersonIndex(name = '') {
      const firstChar = name.trim().charAt(0)
      if (/^[a-zA-Z]$/.test(firstChar)) {
        return firstChar.toUpperCase()
      }
      if (/^[\u4e00-\u9fa5]$/.test(firstChar)) {
        return this.getChineseInitial(firstChar)
      }
      return '#'
    },
    getChineseInitial(char) {
      const initials = [
        {letter: 'A', boundary: '阿'},
        {letter: 'B', boundary: '芭'},
        {letter: 'C', boundary: '擦'},
        {letter: 'D', boundary: '搭'},
        {letter: 'E', boundary: '蛾'},
        {letter: 'F', boundary: '发'},
        {letter: 'G', boundary: '噶'},
        {letter: 'H', boundary: '哈'},
        {letter: 'J', boundary: '击'},
        {letter: 'K', boundary: '喀'},
        {letter: 'L', boundary: '垃'},
        {letter: 'M', boundary: '妈'},
        {letter: 'N', boundary: '拿'},
        {letter: 'O', boundary: '哦'},
        {letter: 'P', boundary: '啪'},
        {letter: 'Q', boundary: '期'},
        {letter: 'R', boundary: '然'},
        {letter: 'S', boundary: '撒'},
        {letter: 'T', boundary: '塌'},
        {letter: 'W', boundary: '挖'},
        {letter: 'X', boundary: '昔'},
        {letter: 'Y', boundary: '压'},
        {letter: 'Z', boundary: '匝'}
      ]

      for (let i = initials.length - 1; i >= 0; i--) {
        if (char.localeCompare(initials[i].boundary, 'zh-Hans-CN') >= 0) {
          return initials[i].letter
        }
      }

      return '#'
    },
    selectPerson(name) {
      this.value = name
      this.showPersonPopup = false
      this.onSearch()
    },
    changeMultipule() {
      let sjplsp = Vue.cookie.get('sjplsp')
      if (sjplsp === '1') {
        this.$emit('clearResult')
        this.$emit('update:isMultiple', !this.isMultiple);
      } else {
        this.$toast.fail('无批量审批权限!');
      }
    }
  }
}
</script>

<style scoped>

.img {
  width: 30px;
  height: 25px;
}

.user-select-icon {
  width: 28px;
  height: 28px;
  margin-right: 5px;
  object-fit: contain;
  vertical-align: middle;
}

.search {
  display: flex;
  align-items: center;
  width: 100%;
  height: 60px;
  background-color: #0093FF;
  position: fixed;
  left: 0;
  top: 40px;
  z-index: 998;
}

.search-item {
  flex: 1;
}

.person-popup {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: linear-gradient(180deg, #eef6ff 0%, #f7f8fa 22%, #f7f8fa 100%);
}

.person-popup-header {
  min-height: 68px;
  padding: calc(env(safe-area-inset-top) + 10px) 18px 10px;
  background: rgba(255, 255, 255, 0.94);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #eceff4;
  box-shadow: none;
}

.person-popup-header-main {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.person-popup-title-text {
  font-size: 22px;
  line-height: 34px;
  font-weight: 700;
  color: #1f2d3d;
}

.person-popup-title {
  display: none;
}

.person-popup-content {
  flex: 1;
  overflow-y: auto;
  padding: 0;
}

.person-popup-content :deep(.van-index-bar__index--active) {
  color: #1989fa!important;
  /* 不需要 !important 也能覆盖默认样式 */
}

.person-popup-content .van-index-bar {
  min-height: 100%;
  padding-top: 0;
  border-radius: 0;
/*  background-color: #fff;*/
  box-shadow: none;
}

.person-popup-content .van-index-anchor {
  padding: 14px 18px 8px;
  font-size: 20px;
  font-weight: 700;
  color: #8fa1b7;
  background-color: #fff;
}

.person-popup-content .van-cell {
  padding: 14px 18px;
}

.person-popup-content .van-cell__title {
  color: #1f2d3d !important;
  font-size: 16px !important;
  font-weight: 500;
}

.person-popup-content .van-cell::after {
  left: 18px;
  right: 18px;
  border-bottom: 1px solid #f1f4f8;
}

.person-popup-content .van-index-bar__sidebar {
  right: 8px;
  padding: 8px 0;
  border-radius: 14px;
  background-color: rgba(255, 255, 255, 0.92);
  box-shadow: 0 4px 12px rgba(31, 45, 61, 0.08);
}

.person-popup-content .van-index-bar__index {
  color: #5d94f8;
  font-weight: 700;
}

.person-popup-content .van-index-bar__index--active {
  color: #1989fa;
}

.person-popup-header > .van-icon-cross {
  display: none;
}

.person-popup-close {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: #f2f6fc;
  color: #5b6b7f;
  display: flex;
  align-items: center;
  justify-content: center;
}

.person-popup-close .van-icon {
  color: #5b6b7f;
}

.person-popup-loading,
.person-popup-empty {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  background-color: transparent;
}

.filter {
  width: 90px;
  background-color: #0093FF;
  display: flex;
  justify-content: center;
  align-items: center;
  /*flex-direction: column;*/
  /*align-items: center;*/
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
{
  opacity: 0;
}

/*.filter-item .van-info {*/
/*  display: none;*/
/*}*/

.van-cell__title {
  font-size: 14px !important;
}

.right {
  overflow: scroll;
}

.mix-tree-item {
  width: calc(100% - 20px);
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333;
  transition: 0.2s;
  height: 0;
  opacity: 0;
  position: relative;
  margin-left: 10px;
  margin-right: 10px;
}

/*.selectArea:hover {
  background-color: #f7f7f7; !* hover 效果 *!
}*/

.mix-tree-item:active {
  background-color: #f2f2f2;
}

.mix-tree-item.border {
  border-bottom: 1px solid #eee;
}

.mix-tree-item.show {
  height: 50px;
  opacity: 1;

/*  background-color: #fff;        !* 白底卡片 *!
  border-radius: 6px;            !* 圆角 *!
  box-shadow: 0 1px 3px rgba(0,0,0,0.1); !* 卡片阴影 *!
  margin-bottom: 8px;            !* 卡片之间留缝隙 *!
  transition: background-color 0.15s;*/
  border-bottom: 1px solid #eee;
}

.mix-tree-icon {
  width: 13px;
  height: 13px;
  margin-right: 4px;
  opacity: .9;
}

.mix-tree-item .showchild:before {
  transform: rotate(90deg);
}

.mix-tree-item.last:before {
  opacity: 0;
}

.badge {
  width: 30px;
  height: 15px;
  background-color: #ee0a24;
  color: #FFFFFF;
  font-size: 12px;
  text-align: center;
  line-height: 15px;
  border-radius: 15px;
  margin-left: 5px;
}

.isBold {
  font-weight: bold;
}

.active {
  background-color: #e6f7ff; /* 浅蓝背景 */
  color: #1890ff; /* 高亮文字 */
  font-weight: bold; /* 可选：加粗 */
}

.selectArea {
  padding-left: 5px;
}


</style>


<style>
.van-sidebar-item--select::before {
  background-color: #5d94f8 !important;
}

.van-tree-select__item--active {
  color: #5d94f8 !important;
}

.van-sidebar {
  width: 110px !important;
  background-color: #fff !important;
  border-right: 1px solid #eeeeee !important;
}

.van-sidebar-item {
  background-color: #fff !important;
}

.van-sidebar-item--select {
  color: #5d94f8 !important;
}

.van-tree-select__nav {
  flex: none !important;
}

.van-search__action {
  background-color: #f7f8fa !important;
}

/*.van-popover {*/
/*  display: block!important;*/
/*}*/

.van-popover__arrow {
  right: 5px !important;
}

</style>
